import { Subject, takeUntil } from 'rxjs';

import { AppConstants } from '@app/core/constants/app.constants';
import { EmbedAuthService } from '../auth/embed-auth.service';
import { Injectable } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';

export class IdleStates {
  static readonly IDLE_END = 'IDLE_END';
  static readonly TIMEOUT = 'TIMEOUT';
  static readonly COUNTDOWN = 'COUNTDOWN';
}

@Injectable({ providedIn: 'root' })
export class IdleService {
  private running = false;
  private destroy$ = new Subject<void>();
  idleState$ = new Subject<{ state: string; countdown?: number }>();

  constructor(private idle: UserIdleService, private embedAuthService: EmbedAuthService) {
    this.idle
      .onTimerStart()
      .pipe(takeUntil(this.destroy$))
      .subscribe((countdown) => {
        if (!countdown) {
          this.idleState$.next({ state: IdleStates.IDLE_END });
        } else {
          this.idleState$.next({
            state: IdleStates.COUNTDOWN,
            countdown: AppConstants.idleGraceTimeInSeconds - countdown
          });
        }
      });

    this.idle
      .onTimeout()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.idleState$.next({ state: IdleStates.TIMEOUT });
      });
  }

  destroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isRunning() {
    return this.running;
  }

  startTimer() {
    if (this.isRunning()) return;
    this.start();
  }

  resetTimer() {
    this.destroyTimer();
    this.start();
  }

  stopTimer() {
    if (this.isRunning()) this.idle.stopTimer();
  }

  destroyTimer() {
    if (this.isRunning()) {
      this.idle.stopWatching();
      this.running = false;
    }
  }

  private start() {
    this.running = true;
    // this.idle.setConfigValues({
    //   idle: !this.embedAuthService.isEmbedded()
    //     ? AppConstants.idleTimeInSeconds
    //     : AppConstants.embedIdleTimeInSeconds,
    //   timeout: AppConstants.idleGraceTimeInSeconds
    // });
    this.idle.setConfigValues({
      idle: AppConstants.idleTimeInSeconds,
      timeout: AppConstants.idleGraceTimeInSeconds
    });
    this.idle.startWatching();
  }
}
